import { useState } from 'react'

const loadPrefs = (key) => {
  try {
    return JSON.parse(localStorage.getItem(key))
  } catch {
    return null
  }
}

const savePrefs = (key, data) => {
  try {
    localStorage.setItem(key, JSON.stringify(data))
  } catch {
    // storage full or blocked
  }
}

const isPlainObject = (value) => {
  return value !== null && typeof value === 'object' && !Array.isArray(value)
}

const mergePrefs = (saved, defaults) => {
  if (saved == null) return defaults
  if (isPlainObject(saved) && isPlainObject(defaults)) {
    return { ...defaults, ...saved }
  }
  return saved
}

const usePersistedState = (key, defaults) => {
  const [value, setValue] = useState(() => mergePrefs(loadPrefs(key), defaults))

  const update = (newValue) => {
    setValue(newValue)
    savePrefs(key, newValue)
  }

  return [value, update]
}

export default usePersistedState
